export const isExternalUrl = (url: string): boolean => {
  try {
    return new URL(url).host !== window.location.host;
  } catch {
    return false;
  }
};
